import React from "react";
import ErrorProps from "./error.props";
import { Container, Row, Col, Button } from "react-bootstrap";

const ErrorBox = (props: ErrorProps) => (
  <Container fluid className={`mpng-ux-error ${props.className ?? ""}`} data-testid="mpng-error-container">
    <Row className="my-5">
      <Col xs={12}>
        <h1 className="text-center mt-2 text-primary" data-testid="mpng-error-primary">
          {props.primaryMsg || "An unknown error occurred"}
        </h1>
        {props.secondaryMsg && (
          <h2 className="text-center mt-2 text-secondary" data-testid="mpng-error-secondary">
            {props.secondaryMsg}
          </h2>
        )}
      </Col>
      <Col xs={12} className="text-center mt-4">
        <Button
          variant="primary"
          data-testid="mpng-error-button"
          onClick={() => {
            if (typeof props.handleClick === "function") {
              props.handleClick();
            }
          }}
        >
          {props.buttonText}
        </Button>
      </Col>
    </Row>
  </Container>
);

export default ErrorBox;
